import { node } from '@/plugins/axios'

export * from './stockview-stock.service'
export * from './stockview-dashboard.service'
export * from './stockview-listing.service'

export const getSellers = async () => {
  try {
    const { data } = await node.get('/me/sellers', {
      params: { feed: 'stockview' }
    })
    return data
  } catch (err) {
    throw err
  }
}
